// Import of actions
import * as EvaluationActions from "../actions/evaluation.actions";
import { IDashboardItemEvaluation } from "../../models/types";

export type EvaluationState = IDashboardItemEvaluation[];

export const initialState: IDashboardItemEvaluation[] = [];

export function evaluationReducer(
  state = initialState,
  action: EvaluationActions.Actions
): EvaluationState {
  switch (action.type) {
    case EvaluationActions.RESET_STATE: {
      return initialState;
    }

    case EvaluationActions.ADD: {
      return state.find(item => item.id === action.payload.id)
        ? state
        : [...state, action.payload];
    }

    case EvaluationActions.REPLACE: {
      return [
        ...state.filter(
          item => item.id !== action.payload.id
        ),
        action.payload // payload is FHIR resource
      ];
    }

    case EvaluationActions.UPDATE: {
      return state.map(item => {
        return item.id === action.payload.id
          ? { ...item, ...action.payload }
          : item;
      });
    }

    case EvaluationActions.DELETE: {
      return state.filter(
        item => item.id !== action.payload.id
      );
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/evaluation.reducer.ts